export const getEmptyStateTranslations = (type) => {
  const translationKeys = {
    published: {
      info: "experiences.empty_state.info",
      subtitle: "experiences.empty_state.subtitle"
    },
    draft: {
      info: "experiences.empty_state.draft_info",
      subtitle: "experiences.empty_state.draft_subtitle"
    },
    deactivated: {
      info: "experiences.empty_state.deactivated_info",
      subtitle: "experiences.empty_state.deactivated_subtitle"
    }
  }
  return translationKeys[type] || translationKeys.published||translationKeys.draft||translationKeys.deactivated
}

export const getActionTranslations = (t) => ({
  delete: {
    title: t("experiences.delete.title"),
    message: t("experiences.delete.info"),
    success: t("experiences.delete.success"),
    error: t("experiences.delete.error"),
    confirmLabel: t("global.delete"),
    warningText: t("experiences.delete.message")
  },
  deactivate: {
    title: t("experiences.deactivate.deactivate_title"),
    message: t("experiences.deactivate.deactivate_info"),
    success: t("experiences.deactivate.deactivate_Sucess"),
    error: t("experiences.deactivate.deactivate_error"),
    confirmLabel: t("global.deactivate")
  },
  duplicate: {
    success: "Listing successfully duplicated to drafts.",
    error: "Failed to duplicate."
  },
  publish: {
    title: t("experiences.publish.title"),
    message: t("experiences.publish.info"),
    success: t("experiences.publish.success"),
    error: t("experiences.publish.error"),
    confirmLabel: t("global.publish")
  }
}) 